import type { HttpInterceptorFn } from '@angular/common/http';

/** Applies default headers for JSON API requests. */
export const apiInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.startsWith('/api') || req.url.includes('/api/')) {
    return next(
      req.clone({
        setHeaders: {
          Accept: 'application/json',
        },
      }),
    );
  }

  return next(req);
};
